import { IApplicationState } from '../../types/redux';

export function selectBuilders(state: IApplicationState) {
  const { builders } = state;

  return builders;
}
